import React, { ElementType, FC } from 'react'
import { includes } from 'lodash'
import * as Icons from 'components/Common/SvgIcons'
import { EllipseIcon, TickIcon } from 'components/Common/SvgIcons/index'
import { AppFC } from 'types'
import { TileLabel, TileWrapper } from './style'

interface ITileProps {
  value: string | string[]
  label: string
  optionValue: string
  onChange: (input: string) => void
  className?: string
  isCheckBox?: boolean
  icon?: string
}

interface ICheckBox {
  isValueSelected: boolean
}

interface ITileLabelContainer {
  label: string
  isValueSelected: boolean
  OptionIcon: ElementType
}

const Tile: FC<ITileProps> = ({
  value,
  onChange,
  label,
  optionValue,
  className = '',
  isCheckBox = false,
  icon = '',
}) => {
  const handleSelect = (option: string) => {
    onChange(option)
  }
  const OptionIcon = Icons[icon]
  const isValueSelected = includes(value, optionValue)

  return (
    <TileWrapper
      key={optionValue}
      onClick={() => handleSelect(optionValue)}
      className={className}
      isValueSelected={isValueSelected}
    >
      <div className={`flex gap-2 justify-start `}>
        {OptionIcon && (
          <OptionIcon
            className={` ${includes(value, optionValue) ? 'fill-tertiary' : 'fill-silver'}`}
          />
        )}
        <TileLabelContainer
          label={label}
          OptionIcon={OptionIcon}
          isValueSelected={isValueSelected}
        />
        {isCheckBox && <CheckBox isValueSelected={isValueSelected} />}
      </div>
    </TileWrapper>
  )
}

const CheckBox: AppFC<ICheckBox> = ({ isValueSelected }) => {
  return (
    <span className="relative h-6 w-6">
      <EllipseIcon
        className={`rounded-full h-[25px] w-[25px] ${
          isValueSelected ? 'fill-tertiary' : 'fill-primary-disabledText opacity-50'
        }`}
      />
      <TickIcon
        className={`${
          isValueSelected ? 'stroke-[12px] stroke-white w-[15px]' : 'stroke-0 w-0'
        } absolute top-[5px] left-1/2 -translate-x-2/4`}
      />
    </span>
  )
}

const TileLabelContainer: AppFC<ITileLabelContainer> = ({ label, OptionIcon, isValueSelected }) => {
  return (
    <span className={`inline-flex flex-col ${OptionIcon && <OptionIcon /> ? 'pl-4' : ''}`}>
      <TileLabel isValueSelected={isValueSelected}>{label}</TileLabel>
    </span>
  )
}

export default Tile
